import { createContext, useContext, useState } from 'react';

const MessageNotificationContext = createContext();

export const useMessageNotification = () => {
  const context = useContext(MessageNotificationContext);
  if (!context) {
    throw new Error('useMessageNotification must be used within MessageNotificationProvider');
  }
  return context;
};

export const MessageNotificationProvider = ({ children }) => {
  const [shouldReduceCount, setShouldReduceCount] = useState(0);
  const [reductionAmount, setReductionAmount] = useState(1);

  const triggerCountReduction = (amount = 1) => {
    setReductionAmount(amount);
    setShouldReduceCount(prev => prev + 1);
  };

  return (
    <MessageNotificationContext.Provider value={{
      shouldReduceCount,
      reductionAmount,
      triggerCountReduction
    }}>
      {children}
    </MessageNotificationContext.Provider>
  );
};
